
import Button from '../../../components/base/Button';

export default function HeroSection() {
  return (
    <section className="min-h-screen flex items-center justify-center bg-white relative overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/3fdc746f0d1d84f2cde4df046cd392e8/27ad342fed668d4e9d1862f7c69ee081.jpeg')`
        }}
      >
        <div className="absolute inset-0 bg-white/70"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-7xl font-light text-gray-900 mb-6 leading-tight">
            Transforming challenges into 
            <span className="block font-medium">visual clarity</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed max-w-3xl mx-auto">
            Designer, photographer, and art director helping tell their stories through thoughtful visuals and strategic workflow solutions.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button href="/work" size="lg" className="rounded-none">
              View Selected Work
            </Button>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-gray-400 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}